import { render, staticRenderFns } from "./chg-pass.vue?vue&type=template&id=a4118964&scoped=true&"
import script from "./chg-pass.vue?vue&type=script&lang=js&"
export * from "./chg-pass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4118964",
  null
  
)

export default component.exports